import { MetaRoot } from 'util/metaPath'

import { createCpfCnsCalculation, createDescricaoCalculation } from '../calculator-atestadoCommon'
import AtestadoModel, { CidadaoAtestado } from '../components/model-atestado'
import { getSolicitacaoFraldasGeriatricasText } from './utils-solicitacaoFraldasGeriatricas'

export const createSolicitacaoFraldasGeriatricasCalculations = (
  path: MetaRoot<AtestadoModel>,
  cidadao: CidadaoAtestado
) => [
  createCpfCnsCalculation(path),
  createDescricaoCalculation(
    path,
    [
      path.tamanhoFralda.absolutePath(),
      path.unidadesPorDia.absolutePath(),
      path.cid10.absolutePath(),
      path.cpfCns.absolutePath(),
      path.naoPossui.absolutePath(),
    ],
    (values) => getSolicitacaoFraldasGeriatricasText({ cidadao, values })
  ),
]
